<template>
    <div class="container-bahai">
        <AuthHeader/>
        <div class="container is-centered sign-in">
            <SignInForm
                :mode="routerName"
                :button-title="$t('login')"
                :header-title="$t('log_in')"
                show-errors
                show-forgot-password
            />
        </div>
    </div>
</template>

<script>
    import SignInForm from '@/components/SignInForm.vue'
    import AuthHeader from '@/components/AuthHeader.vue'

    export default {
        name: "SignIn",
        components: {SignInForm, AuthHeader},
        computed: {
            routerName() {
                return this.$route.name;
            }
        }
    }
</script>

<style scoped>

</style>
